import { useTranslation } from 'react-i18next'
import BaseModalEventBunpimay from './BaseModalEventBunpimay'
import iconWaterGun from 'assets/images/eventBunpimay/iconGunWaterPopup.png'
import headerPopup from 'assets/images/eventBunpimay/headerPopupWin.png'

function ModalBunpimayPairingSuccess({
	show,
	numberPairing = 0,
	onHide,
	...otherProps
}) {
	const { t, i18n } = useTranslation()
	let textDescription = t('event.bunpimay.modal.win.pairing_success').replace(
		'_NUMBER_',
		numberPairing,
	)
	if (i18n.language === 'en' && numberPairing === 1) {
		textDescription = "1 water gun has been added to your collection"
	}


	return (
		<BaseModalEventBunpimay
			srcImgHeader={headerPopup}
			show={show}
			onHide={onHide}
			classProp="disabled-transition"
			{...otherProps}
		>
			<div className="modal-win">
				<div className="modal-win-content">
					<div className="number-item">{`${numberPairing} X`}</div>
					<img src={iconWaterGun} />
				</div>
				<div className="modal-win-description">
					{textDescription}
				</div>
			</div>
		</BaseModalEventBunpimay>
	)
}

export default ModalBunpimayPairingSuccess
